import { AbstructRoadStructuresAttributeConvert } from "./AbstructRoadStructuresAttributeConvert";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import GeoJSON from "ol/format/GeoJSON";

/**
 * 画面サイズ（横幅）
 */
const VALUE_WIDTH = 300;

/**
 * 画面サイズ（縦幅）
 */
const VALUE_HEIGHT = 300;

/**
 *  画面サイズ（縦幅）詳細表示時
 */
const VALUE_MAX_WIDTH = 400;

/**
 * 画面タイトル
 */
const VALUE_TITLE = "点検DB（トンネル）";

/**
 * 点検データ（道路橋）属性変換クラス
 */
export class RoadStructuresTunnelsAttributeConvert extends AbstructRoadStructuresAttributeConvert {
  /**
   * 地物タイプ
   */
  _featureType = FeatureType.Bridges;

  /**
   * 出力JSONファイル名
   */
  protected _jsonFileName = "insp_tunn_yyyyMMdd_HHmmss.geojson";

  /**
   * 出力CSVファイル名
   */
  protected _csvFileName = "insp_tunn_yyyyMMdd_HHmmss.csv";

  /**
   * コンストラクタ
   * @param geoJSON
   */
  constructor(geoJSON: any) {
    super(geoJSON);
  }

  /**
   * 画面用フォーマットに変換
   */
  getViewFormatData(): AttributeView {
    const GeoJson = new GeoJSON().readFeature(this._geoJSON).get("attribute");
    // 画面項目定義リスト
    const items = [
      {
        key: "施設ID",
        value: GeoJson.shisetsu_id,
        isSimple: true,
      },
      {
        key: "施設区分",
        value: GeoJson.shisetsu_kubun,
        isSimple: true,
      },
      {
        key: "道路管理者コード",
        value: GeoJson.kanrisya_code,
        isSimple: true,
      },
      {
        key: "施設名",
        value: GeoJson.syogen.shisetsu.meisyou,
        isSimple: true,
      },
      {
        key: "施設名（フリガナ）",
        value: GeoJson.syogen.shisetsu.furigana,
        isSimple: true,
      },
      {
        key: "路線名",
        value: GeoJson.syogen?.rosen?.meisyou,
        isSimple: true,
      },
      {
        key: "建設年度",
        value: GeoJson.syogen?.kensetsu_nendo,
        isSimple: true,
      },
      {
        key: "延長(m)",
        value: GeoJson.syogen?.enchou,
        isSimple: true,
      },
      {
        key: "幅員(m)",
        value: GeoJson.syogen.fukuin,
        isSimple: false,
      },
      {
        key: "管理者区分",
        value: GeoJson.syogen.kanrisya.kubun,
        isSimple: false,
      },
      {
        key: "管理者名",
        value: GeoJson.syogen?.kanrisya?.meisyou,
        isSimple: false,
      },
      {
        key: "管理事務所名",
        value: GeoJson.syogen.kanrisya.jimusyo,
        isSimple: false,
      },
      {
        key: "都道府県コード",
        value: GeoJson.syogen.gyousei_kuiki.todoufuken_code,
        isSimple: false,
      },
      {
        key: "都道府県名",
        value: GeoJson.syogen.gyousei_kuiki.todoufuken_mei,
        isSimple: false,
      },
      {
        key: "市区町村コード",
        value: GeoJson.syogen.gyousei_kuiki.shikuchouson_code,
        isSimple: false,
      },
      {
        key: "市区町村名",
        value: GeoJson.syogen.gyousei_kuiki.shikuchouson_mei,
        isSimple: false,
      },
      {
        key: "緯度",
        value: GeoJson.syogen.ichi.ido,
        isSimple: false,
      },
      {
        key: "経度",
        value: GeoJson.syogen.ichi.keido,
        isSimple: false,
      },
      {
        key: "点検実施年度",
        value: GeoJson.tenken.nendo,
        isSimple: false,
      },
      {
        key: "判定区分",
        value: GeoJson.tenken.kiroku.hantei_kubun,
        isSimple: false,
      },
      {
        key: "措置状況",
        value: GeoJson.tenken.syuzen.sochi_joukyou,
        isSimple: false,
      },
    ];
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues = items.map((item) => {
      return new AttributeValue(item.key, item.value, item.isSimple);
    });
    const attributeView: AttributeView = {
      width: VALUE_WIDTH,
      height: VALUE_HEIGHT,
      maxheight: VALUE_MAX_WIDTH,
      title: VALUE_TITLE,
      attributeValues,
      csvOutputUnPossibility: true,
      jsonOutputUnPossibility: true,
    };
    return attributeView;
  }
}
